import React from 'react';
import GeographySelectorForm from '../components/reports/GeographySelectorForm';
import InlinePDFViewer from '../components/reports/InlinePDFViewer';
import { useGeographyContext } from '../contexts/GeographyContext';

const MovementSecurityPage: React.FC = () => {
  const {
    countries,
    states,
    lgas,
    selectedContinent,
    selectedCountry,
    selectedState,
    selectedLga,
    setSelectedContinent,
    setSelectedCountry,
    setSelectedState,
    setSelectedLga,
    loading,
    error,
  } = useGeographyContext();


  if (loading) {
    return <div className="flex justify-center items-center h-96"><p>Loading...</p></div>;
  }

  if (error) {
    return <div className="flex justify-center items-center h-96"><p>{error}</p></div>;
  }
  
  return (
    <div className="h-full flex flex-col">
      <div className="mb-4">
        <h2 className="text-2xl font-bold text-gray-900">Movement Security</h2>
        <p className="text-gray-600 mt-1">Travel and movement security advisories by region</p>
      </div>

      <GeographySelectorForm
        selectedContinent={selectedContinent}
        countries={countries}
        states={states}
        lgas={lgas}
        selectedCountry={selectedCountry}
        selectedState={selectedState}
        selectedLga={selectedLga}
        onContinentChange={setSelectedContinent}
        onCountryChange={setSelectedCountry}
        onStateChange={setSelectedState}
        onLgaChange={setSelectedLga}
      />

      <div className="mt-6">
        <InlinePDFViewer 
          reportType="movement_security"
          selectedCountry={countries.find(c => c.id === selectedCountry)}
          selectedState={states.find(s => s.id === selectedState)}
          selectedLga={lgas.find(l => l.id === selectedLga)}
        />
      </div>
    </div>
  );
};

export default MovementSecurityPage;
